module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAYAAADlep81AAAAAXNSR0IArs4c6QAAAEJJREFUSA3t0rENADAIA0HCatm/yEREYoFvXTytG+vwmXengq6DumwVC9FHFFKIBCh3QwqRAOVuSCESoNwNKUQClH+wcwM6aq3eqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/High Patch.png
// module id = 307
// module chunks = 7